import DialogContent from '@mui/material/DialogContent'
import { styled } from '@mui/material/styles'
import React from 'react'

import Dialog from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog-header'
import { defaultNewHook } from '@/app/module/phonenumbers/definitions'

import Hook, { HookProps } from './hook'

type Props = Omit<HookProps, 'hook'> & { onClose: () => void }

const AddRuleDialog: React.FC<Props> = ({ onClose, ...props }) => (
  <StyledDialog closeOnBackdropClick open onClose={onClose}>
    <DialogHeader title={getDialogTitle(props.type)} onClose={onClose} />
    <DialogContent>
      <Content>
        <Hook hook={defaultNewHook} {...props} />
      </Content>
    </DialogContent>
  </StyledDialog>
)

const getDialogTitle = (type: string) => {
  switch (type) {
    case 'sms':
      return 'Add Incoming SMS Rule'

    case 'voice':
      return 'Add Incoming Voice Rule'

    case 'whatsapp':
      return 'Add Incoming WhatsApp Rule'

    default:
      return 'Add Rule'
  }
}

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    width: '1400px',
    maxWidth: '90vw',
  },
}))

const Content = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 0, 0, 0),
}))

export default AddRuleDialog
